module.exports = __webpack_public_path__ + "static/media/0295_Small.f33f9a04.jpg";